import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { trpc, useTRPC } from "../../../shared/api/trpc";

export type Dashboard = Awaited<ReturnType<typeof trpc.app.dashboard.query>>;

export function useDashboard() {
  const trpc = useTRPC();
  const dashboardQuery = useQuery(trpc.app.dashboard.queryOptions());

  const reload = useCallback(async () => {
    await dashboardQuery.refetch();
  }, [dashboardQuery.refetch]);

  return {
    dashboard: dashboardQuery.data ?? null,
    error: dashboardQuery.error instanceof Error ? dashboardQuery.error.message : dashboardQuery.error ? String(dashboardQuery.error) : null,
    reload,
  };
}
